/* eslint-disable camelcase */
import {
    checkUserHasTalenyaEmail,
    isAutomation,
    getMappedOptions,
    getCurrentEnv,
    USER_OPTIONS_MAP,
    isHotjarInited,
} from './TrackingService';
import Logger from '../logger';

const angular = require('angular');

const userDataStr = 'trackUserData';
const ls = window.localStorage;

const getUser = () => {
    try {
        const userData = ls.getItem(userDataStr);

        if (userData) {
            const user = JSON.parse(userData) || {};

            user.employerName = checkUserHasTalenyaEmail(user) ? 'Talenya' : user.employerName;
            user.isTalenyaUser = (user.userRoles || []).includes('TALENYA');

            return getMappedOptions({
                ...user,
                screenHeight: window.screen.height,
                screenWidth: window.screen.width,
            }, USER_OPTIONS_MAP);
        }

        return null;
    } catch (error) {
        Logger.error(error);
        return null;
    }
};

const hotjarAnalytics = {
    identifyUser() {
        try {
            if (!isHotjarInited()) {
                return;
            }

            const user = getUser();

            if (isAutomation(user)) {
                return;
            }

            if (!user) {
                throw new Error('[hotjarModule.identifyUser] -- User is not defined');
            }

            const userParams = {
                ...user,
                environment: getCurrentEnv(),
            };

            window.hj('identify', user._id, userParams);
        } catch (error) {
            Logger.error(error);
        }
    },
    trackEvent(tags) {
        if (!isHotjarInited()) {
            return;
        }

        const user = getUser();

        if (isAutomation(user)) {
            return;
        }

        const tagsToTrack = [...tags, getCurrentEnv()];

        window.hj('tagRecording', tagsToTrack);
    },
};

export default angular.module('ngHotjar', [])
    .config(registerDecorator)
    .name;

registerDecorator.$inject = ['$provide'];
function registerDecorator($provide) {
    $provide.value('hotjar', hotjarAnalytics);
}
